var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20,8c2.206,0,4-1.794,4-4s-1.794-4-4-4-4,1.794-4,4,1.794,4,4,4Zm0-6c1.103,0,2,.897,2,2s-.897,2-2,2-2-.897-2-2,.897-2,2-2Zm1.868,8.301c-.127-.538-.675-.869-1.202-.745-.538.127-.871.665-.745,1.202l1.057,4.489c.184.658.051,1.348-.365,1.893-.419.547-1.056.86-1.748.86H5.135c-.67,0-1.294-.297-1.712-.815-.417-.517-.573-1.183-.439-1.786l2.094-7.777c.74-3.31,3.642-5.621,7.056-5.621.43,0,.859.038,1.275.114.551.098,1.064-.264,1.163-.806.099-.544-.263-1.064-.806-1.163-.534-.097-1.083-.146-1.633-.146C7.776,0,4.072,2.955,3.136,7.144l-2.094,7.776c-.278,1.244.022,2.527.824,3.521.799.991,1.991,1.56,3.269,1.56h1.966c.465,2.279,2.484,4,4.899,4s4.434-1.721,4.899-4h1.965c1.32,0,2.537-.6,3.337-1.646.801-1.048,1.057-2.377.713-3.605l-1.046-4.448Zm-9.868,11.699c-1.302,0-2.402-.839-2.816-2h5.631c-.414,1.161-1.514,2-2.816,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b89fee171e2bbf6cb5ab65f194dc6545.svg";
export { ForwardRef as ReactComponent };